import React, { useState } from "react";
import { Modal, DatePicker, Select, Space, Button } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

interface DatePrintModalProps {
  open: boolean;
  title: string;
  type: "single" | "range";
  statusOptions?: { label: string; value: string }[];
  onPrint: (params: { date?: string; dateFrom?: string; dateTo?: string; status?: string }) => void;
  onCancel: () => void;
  loading?: boolean;
}

const DatePrintModal: React.FC<DatePrintModalProps> = ({
  open,
  title,
  type,
  statusOptions,
  onPrint,
  onCancel,
  loading = false,
}) => {
  const [date, setDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
  const [dateFrom, setDateFrom] = useState<string>(dayjs().startOf("month").format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState<string>(dayjs().endOf("month").format("YYYY-MM-DD"));
  const [status, setStatus] = useState<string | undefined>(undefined);

  const handlePrint = () => {
    if (type === "single") {
      onPrint({ date });
    } else {
      onPrint({ dateFrom, dateTo, status });
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="print" type="primary" loading={loading} onClick={handlePrint}>
          Print
        </Button>,
      ]}
      width={420}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        {type === "single" ? (
          <div>
            <div style={{ marginBottom: 6, fontWeight: 500 }}>Date</div>
            <DatePicker
              style={{ width: "100%" }}
              value={dayjs(date)}
              onChange={(d) => setDate(d ? d.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"))}
            />
          </div>
        ) : (
          <>
            <div>
              <div style={{ marginBottom: 6, fontWeight: 500 }}>Date Range</div>
              <RangePicker
                style={{ width: "100%" }}
                value={[dayjs(dateFrom), dayjs(dateTo)]}
                onChange={(dates) => {
                  if (dates && dates[0] && dates[1]) {
                    setDateFrom(dates[0].format("YYYY-MM-DD"));
                    setDateTo(dates[1].format("YYYY-MM-DD"));
                  }
                }}
              />
            </div>
            {statusOptions && (
              <div>
                <div style={{ marginBottom: 6, fontWeight: 500 }}>Status Filter</div>
                <Select
                  style={{ width: "100%" }}
                  placeholder="All statuses"
                  allowClear
                  options={statusOptions}
                  value={status}
                  onChange={setStatus}
                />
              </div>
            )}
          </>
        )}
      </Space>
    </Modal>
  );
};

export default DatePrintModal;
